import { createContext, useContext, useCallback, useEffect, useState } from "react";
import { LANGUAGES, RTL_LANGS, t as translate, suggestions as sugg } from "@/i18n";

const KEY = "evs.lang";
const LanguageContext = createContext(null);

function initialLang() {
  try {
    const saved = sessionStorage.getItem(KEY);
    if (saved && LANGUAGES.some((l) => l.code === saved)) return saved;
  } catch (e) { /* ignore */ }
  return "en";
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(initialLang);

  const setLang = useCallback((code) => {
    if (!LANGUAGES.some((l) => l.code === code)) return;
    setLangState(code);
    try { sessionStorage.setItem(KEY, code); } catch (e) { /* ignore */ }
  }, []);

  const dir = RTL_LANGS.includes(lang) ? "rtl" : "ltr";

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
  }, [lang, dir]);

  const t = useCallback((key) => translate(lang, key), [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, dir, t, suggestions: sugg(lang), languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
